import React from 'react';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import { Link, withRouter } from 'react-router-dom';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import isEmpty from 'lodash/isEmpty';
import Validator from 'validator';
import Amplify, { Auth } from 'aws-amplify';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import * as Modal from 'react-modal';
import * as _ from 'lodash';
// import SignatureCanvas from 'react-signature-canvas';
import PropTypes from 'prop-types';
import scrollToComponent from 'react-scroll-to-component';
import { animateScroll as scroll } from 'react-scroll';

import Tooltip from '@material-ui/core/Tooltip';
import * as SecretKeys from '../../ENV.json';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';
import Consumer from '../consumer/consumerSignup';
import Header from '../Header/header';
import MaskInputEinNumber from '../common/maskInputEinNumber';
import MaskInputNumber from '../common/maskInputNumber';
import TermAndCondition from '../common/termsAndCondition';
import SignatureComponent from '../common/signatureComponent';
import loader from '../../images/Spin-1s-107px.gif';

import {
  saveBusinessUser,
  saveBusinessUserStep1,
  getAllCountry,
  getAllStates,
  getCityByStateId,
  getAllPlans,
  getAffiliateDetailByAffiliateKey,
  confirmUserEmail,
  clearData,
  getBusiness,
  getIndustry,
  checkEmailVerify,
  getPageData,
  requestApiData,
  clearDataEmail,
  clearSignupData,
  GetAllAffiliateUsersByAffiliateType,
} from '../../Actions/actions';
// import CustomSignature from './customSignature';
import SignupText from './signupText';
import TextFieldGroup from '../common/TextFieldGroup';
import PlanPage from './planPage';

Amplify.configure(SecretKeys.awsUserpool);
// const customStyles = {
//   content: {
//     top: '50%',
//     left: '50%',
//     right: 'auto',
//     bottom: 'auto',
//     marginRight: '-50%',
//     transform: 'translate(-50%, -50%)',
//     maxWidth: '1000px',
//   },
// };

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      password: '',
      passwordType: 'password',
      companyTitle: '',
      mobilePhone: '',
      workPhoneNumber: '',
      email: '',
      companyName: '',
      streeAddress: '',
      city: '',
      state: '',
      zipCode: '',
      separateTaxId: '',
      enterpriseType: '',
      startingYear: '',
      webSite: '',
      industryTypeId: '',
      taxId: '',
      errors: {},
      cognitoClientId: '',
      bankruptcyStatus: '',
      dissolvedStatus: '',
      acceptCC: '',
      planPriceId: 0,
      isLoading: false,
      businessTypeId: '',
      roleName: 'Business-User',
      IsCompanyForm: 1,
      // defaultIndexSignC: 1,
      readDisclaimer: '',
      readPrivacyPolicy: '',
      readLetterOfAgency: '',
      readUserAgreement: '',
      errorsCompany: {},
      errorsTermPolicy: {},
      modalIsOpen: false,
      fileError: false,
      totalTaxId: 1,
      file: '',
      code: '',
      indicatorBusiness: '',
      indicatorConsumer: '',
      signatureImageContentType: 'image/png',
      signatureImageFileSize: '',
      errorForcodeverify: false,
      isMounted: false,
      affiliateId: '',
      partnerType: '',
      defaultIndex: 1,
      countryCode: '+1',
      workCountryCode: '+1',
      cityId: '',
      nonWorkPhoneNumber: '',
      showTab: 1,
      affiliateKeyId: '',
      isLoginCheckS: false,
      plansDataAffiliate1: [],
      indexType: 'defaultIndex',
      passwordColor: 'black',
      cchangeSignature: 0,
      signatureDefaultValue: '',
      signatureFontFamily: '',
      emptyErrorSign: 1,
      AllPlansForMember1: [],
      intervalId: 0,
      pageType: 'business',
      enableButtonT: true,
      userDataLogin1: [],
      paymentStatus: 'pending',
      isLoader: false,
      selectedPlanName: '',
      selectedPlanAmount: '',
      BusinessUserDataStep1Data: {},
      cFirstName: '',
      cLastName: '',
      cState: '',
      cSince: '',
      cEmployer: '',
      cEmail: '',
      cPhone: '',
      cPassword: '',
      cNotification: '',
      cUpdateClaim: '',
      serviceFeeAgree: '',
      bankAccount: '',
      otherIndustryType: '',

    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeTaxId = this.onChangeTaxId.bind(this);
    this.onChange1 = this.onChange1.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this._onSelect = this._onSelect.bind(this);
    this._onSelectForBusiness = this._onSelectForBusiness.bind(this);
    this._onSelectForYears = this._onSelectForYears.bind(this);
    this._onSelectForPartner = this._onSelectForPartner.bind(this);

    this.handleSubmitCompany = this.handleSubmitCompany.bind(this);
    this.AckOnchange = this.AckOnchange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.finalSubmit = this.finalSubmit.bind(this);
    this.uploadHandler = this.uploadHandler.bind(this);
    this.onPlanSelect = this.onPlanSelect.bind(this);
    this.codeOnSubmit = this.codeOnSubmit.bind(this);
    this._citySelect = this._citySelect.bind(this);
    this._cSince1 = this._cSince1.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this._countrySelectWork = this._countrySelectWork.bind(this);
    this.onPlanSelectSubmit = this.onPlanSelectSubmit.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
    this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this.handleDataChidData = this.handleDataChidData.bind(this);
    this.viewPassword = this.viewPassword.bind(this);
    this.backClick = this.backClick.bind(this);
  }

  handleDataChidData(data) {
    this.setState({
      showTab: data,
    });
  }

  handleSaveData = (langValue) => {
    this.setState({
      readDisclaimer: langValue.readDisclaimer,
      readPrivacyPolicy: langValue.readPrivacyPolicy,
      readLetterOfAgency: langValue.readLetterOfAgency,
      readUserAgreement: langValue.readUserAgreement,
      IsCompanyForm: 5,
    });
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  backClick() {
    this.setState(state => ({
      IsCompanyForm: state.IsCompanyForm - 1,
    }));
    window.scrollTo(0, 0);
  }

  _citySelect(e) {
    this.setState({ cityId: e.value });
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value });
  }

  _countrySelectWork(e) {
    this.setState({ workCountryCode: e.value });
  }

  viewPassword() {
    if (this.state.passwordType === 'password') {
      this.setState({ passwordType: 'text' });
    } else {
      this.setState({ passwordType: 'password' });
    }
  }

  _cSince1(e) {
    this.setState({ startingYear: e.value, errors: {} });
  }

  componentDidMount() {
    const { GetAllAffiliateUsersByAffiliateType } = this.props
    const { defaultIndex } = this.state
    localStorage.setItem('changePlan', false)
    GetAllAffiliateUsersByAffiliateType(defaultIndex === 1 ? "Business" : "Consumer")


    scroll.scrollToTop();
    this.props.getPageData(7);
    //  this.setState({
    //    intervalId1: 0,
    //  });

    this.setState({ isMounted: true }, () => {
      if (this.state.isMounted) {
        this.setState({ isMounted: false });
        {
          const dataB = {
            lookupTypeId: 1,
          };
          const dataI = {
            lookupTypeId: 2,
          };

          this.props.getAllStates();
          this.props.getAllCountry();
          this.props.getAllPlans({
            pageNumber: 0,
            pageSize: 20,
            searchKeyword: '',
            planUserType: 'Business',
            userId: 0,
            affiliateKey: (this.props.match.params.affiliateKey !== undefined) ? this.props.match.params.affiliateKey : '',
          });
          this.props.getBusiness(dataB);
          this.props.getIndustry(dataI);
        }
      }
    });
  }

  async componentWillMount() {
    const affiliateKeyId = this.props.match.params.affiliateKey;
    if (affiliateKeyId !== '' && affiliateKeyId !== undefined) {
      this.setState({ indexType: 'selectedIndex', isLoader: true });
      await this.props.getAffiliateDetailByAffiliateKey(affiliateKeyId);
    }
    this.setState({ affiliateKeyId });

    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId });
  }

  _onSelect(e) {
    this.setState({ state: e.target.value });
  }

  _onSelectForBusiness(e) {
    this.setState({ businessTypeId: e.value });
  }

  _onSelectForYears(e) {
    this.setState({ industryTypeId: e.value });
  }

  _onSelectForPartner(e) {
    this.setState({ affiliateId: e.value });

  }

  onChangeTaxId(e) {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value === '') {
      if (Number.parseInt(e.target.value, 10) !== 0 || e.target.value === '') {
        this.setState({
          [e.target.name]: e.target.value, errors: {}, errorsTermPolicy: {}, errorsCompany: {},
        });
      }
    }
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value, errors: {}, errorsTermPolicy: {}, errorsCompany: {},
    });
    //  this.setState({ [e.target.name]: e.target.value }, () => { if (this.state.email !== '') { this.props.checkEmailVerify({ email: this.state.email }); } });
    if (e.target.name === 'enterpriseType') {
      if (e.target.value === 'E') {
        this.setState({ modalIsOpen: true });
      }
    }

    this.setState({ passwordColor: 'black' });
    if (e.target.name === 'separateTaxId') {
      if (e.target.value === 'no') {
        this.setState({ totalTaxId: 0 });
      } else {
        this.setState({ totalTaxId: 1 });
      }
    }
  }

  onChange1(e) {
    this.setState({ passwordColor: 'black' });
    //  const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    //  if (re.test(e.target.value) || e.target.value === '') {
    this.setState({ [e.target.name]: e.target.value.trimLeft(), errors: {}, errorsTermPolicy: {} });
    //  }
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  validateInput(data) {
    const errors = {};
    const scrollViews = [];
    if (data.email !== '') {
      const isemailVerified = this.props.data.emailVerifyData;
      if (Object.keys(isemailVerified).length > 0) {
        if (isemailVerified.collectMessage !== undefined) {
          if (isemailVerified.collectMessage.messageShort === 'User email already exist') {
            //  errors.email = 'This user\'s email address has already been added to Collectively';
            errors.email = 'Email address already exists';

            scrollViews.push(this.emailRef);
          }
        }
      }
    }
    if (!Validator.isEmail(data.email)) {
      errors.email = 'Email is Not Valid';
      errors.emailError = true;
      scrollViews.push(this.emailRef);
    }
    if (Validator.isEmpty(data.email)) {
      errors.email = 'Email is Required';
      errors.emailError = true;
      scrollViews.push(this.emailRef);
    }

    if (Validator.isEmpty(data.password)) {
      errors.passwordError = true;
      scrollViews.push(this.passwordRef);
    }
    const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    if (!re.test(data.password)) {
      this.setState({ passwordColor: 'red' });
      errors.passwordError = true;
      scrollViews.push(this.passwordRef);
    }

    if (!data.firstName) {
      errors.firstName = 'First name is Required';
      errors.firstNameError = true;
      scrollViews.push(this.firstNameRef);
    } else if (data.firstName.length < 2 || data.firstName.length > 20) {
      errors.firstName = 'First name should be between 2 to 20 characters';
      errors.firstNameError = true;
      scrollViews.push(this.firstNameRef);
    }

    if (!data.lastName) {
      errors.lastName = 'Last name is Required';
      errors.lastNameError = true;
      scrollViews.push(this.lastNameRef);
    } else if (data.lastName.length < 2 || data.lastName.length > 30) {
      errors.lastName = 'Last name should be between 2 to 30 characters';
      errors.lastNameError = true;
      scrollViews.push(this.lastNameRef);
    }

    if (!data.nonWorkPhoneNumber) {
      errors.nonWorkPhoneNumber = 'Mobile number is Required';
      errors.nonWorkPhoneNumberError = true;
      scrollViews.push(this.newMobilePhoneRef);
    } else if (data.nonWorkPhoneNumber.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.nonWorkPhoneNumber = 'Please enter at least 10 digit';
      errors.nonWorkPhoneNumberError = true;
    }
    if (!data.workPhoneNumber) {
      errors.workPhoneNumber = 'Work mobile number is Required';
      errors.workPhoneNumberError = true;
      scrollViews.push(this.workPhoneNumberRef);
    } else if (data.workPhoneNumber.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.workPhoneNumber = 'Please enter at least 10 digit';
      errors.workPhoneNumberError = true;
      scrollViews.push(this.workPhoneNumberRef);
    }

    if (!data.companyTitle) {
      errors.companyTitle = 'Title/Position is Required';
      errors.companyTitleError = true;
      scrollViews.push(this.companyTitleRef);
    } else if (data.companyTitle.length < 2 || data.companyTitle.length > 20) {
      errors.companyTitle = 'Title/Position should be between  2 to 20 characters';
      errors.companyTitleError = true;
      scrollViews.push(this.companyTitleRef);
    }

    if (scrollViews.length > 0) {
      scrollToComponent(scrollViews[0], {
        offset: 200, align: 'bottom', duration: 500, ease: 'inExpo',
      });
    }
    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  isValidCompany() {
    const { errorsCompany, isValidCompany } = this.validateInputCompany(this.state);
    if (!isValidCompany) {
      this.setState({ errorsCompany });
    }
    return isValidCompany;
  }

  validateInputCompany(data) {
    const errorsCompany = {};
    const scrollViews = [];

    if (Validator.isEmpty(data.companyName)) {
      errorsCompany.companyName = 'Company name is Required';
      errorsCompany.companyNameError = true;
      scrollViews.push(this.companyNameRef);
    } else if (data.companyName.length < 2 || data.companyName.length > 50) {
      errorsCompany.companyName = 'Company name and DBA should be between 2 to 50 characters';
      errorsCompany.companyNameError = true;
      scrollViews.push(this.companyNameRef);
    }

    if (Validator.isEmpty(data.streeAddress)) {
      errorsCompany.streeAddress = 'Street address is Required';
      errorsCompany.streeAddressError = true;
      scrollViews.push(this.streeAddressRef);
    } else if (data.streeAddress.length < 2 || data.streeAddress.length > 50) {
      errorsCompany.streeAddress = 'Street address should be between 2 to 50 characters';
      errorsCompany.streeAddressError = true;
      scrollViews.push(this.streeAddressRef);
    }

    if (!data.city) {
      errorsCompany.city = 'City is Required';
      errorsCompany.cityError = true;
      scrollViews.push(this.cityRef);
    } else if (data.city.length < 2 || data.city.length > 30) {
      errorsCompany.city = 'City should be between 2 to 30 characters';
      errorsCompany.cityError = true;
      scrollViews.push(this.cityRef);
    }

    if (!data.state) {
      errorsCompany.state = 'State is Required';
      errorsCompany.stateError = true;
      scrollViews.push(this.stateRef);
    }

    if (!data.zipCode) {
      errorsCompany.zipCode = 'Zip code is Required';
      errorsCompany.zipCodeError = true;
      scrollViews.push(this.zipCodeRef);
    } else if (data.zipCode.length < 2 || data.zipCode.length > 5) {
      errorsCompany.zipCode = 'Zip code should be between 2 to 5 characters';
      errorsCompany.zipCodeError = true;
      scrollViews.push(this.zipCodeRef);
    }

    if (!data.taxId) {
      errorsCompany.taxId = 'Tax Id is Required';
      errorsCompany.taxIdError = true;
      scrollViews.push(this.taxIdRef);
    }

    if (!data.enterpriseType) {
      errorsCompany.enterpriseType = 'Please choose the size of your company';
      errorsCompany.enterpriseTypeError = true;
    }

    // separateTaxId
    if (data.separateTaxId === 'yes') {
      if (!data.totalTaxId) {
        errorsCompany.totalTaxId = 'Tax Id is Required';
        errorsCompany.totalTaxIdError = true;
        scrollViews.push(this.taxIdRef);
      }
      const re = /[0-9A-F:]+/g;

      if (!re.test(data.totalTaxId)) {
        errorsCompany.totalTaxId = 'Please add additional ein’s here';
        errorsCompany.totalTaxIdError = true;
        scrollViews.push(this.taxIdRef);
      }
      //  if (data.totalTaxId.length > 3) {
      //    errorsCompany.totalTaxId = 'Enter max 3 number ';
      //    errorsCompany.totalTaxIdError = true;
      //    scrollViews.push(this.taxIdRef);
      //  }
    }


    //  if (!data.webSite) {
    //    errorsCompany.webSite = 'Website is Required';
    //    errorsCompany.webSiteError = true;
    //    scrollViews.push(this.webSiteRef);
    //  } else {
    const webSiteRe = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    if (data.webSite !== '') {
      if (!webSiteRe.test(data.webSite)) {
        errorsCompany.webSite = 'Invalid url';
        errorsCompany.webSiteError = true;
        scrollViews.push(this.webSiteRef);
        //  }
      }
    }

    if (!data.industryTypeId) {
      errorsCompany.industryTypeId = 'Industry is Required';
      errorsCompany.industryTypeIdError = true;
      scrollViews.push(this.IndustryDataoptionsRef);
    }
    if (!data.bankruptcyStatus) {
      errorsCompany.bankruptcyStatus = 'Bankruptcy is Required';
      errorsCompany.bankruptcyStatusError = true;
      scrollViews.push(this.bottomDownRef);
    }
    if (!data.separateTaxId) {
      errorsCompany.separateTaxId = 'Separate EINs is Required';
      errorsCompany.separateTaxIdError = true;
      scrollViews.push(this.bottomDownRef);
    }
    if (!data.acceptCC) {
      errorsCompany.acceptCC = 'Company Credit Cards is Required';
      errorsCompany.acceptCCError = true;
      scrollViews.push(this.bottomDownRef);
    }
    if (!data.dissolvedStatus) {
      errorsCompany.dissolvedStatus = 'Dissolve is Required';
      errorsCompany.dissolvedStatusError = true;
      scrollViews.push(this.bottomDownRef2);
    }


    if (!data.startingYear) {
      errorsCompany.startingYear = 'Starting year is Required';
      errorsCompany.startingYearError = true;
    }

    if (scrollViews.length > 0) {
      scrollToComponent(scrollViews[0], {
        offset: 200, align: 'bottom', duration: 500, ease: 'inExpo',
      });
    }
    return {
      errorsCompany,
      isValidCompany: isEmpty(errorsCompany),
    };
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { history } = this.props;
    const { firstName, lastName } = this.state;
    if (this.isValid()) {
      await this.setState({
        signatureDefaultValue: `${firstName} ${lastName}`,
        errors: {},
      }, async () => {
        await this.props.saveBusinessUserStep1(this.state);
        await history.push({ pathname: '/signup-step1' });
      });

      //  const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
      //  this.setState({ intervalId1: intervalId });
    }
  }

  onPlanSelectBar(id, selectedPlanAmount, planData) {
    this.setState({
      planPriceId: id,
      selectedPlanAmount,
      selectedPlanName: planData.planName,
    });
    this.onPlanSelectSubmit();
  }

  onPlanSelect(e) {
    const id = e.value;
    this.setState({
      planPriceId: id,
    });
  }

  onPlanSelectSubmit() {
    const partnerType = this.props.match.params.partnerType;
    if (partnerType === 'Both' || typeof partnerType === 'undefined') {
      this.setState({
        IsCompanyForm: 4,
        defaultIndex: 1,
      });
      scrollToComponent(this.termsAndConditionsRef, {
        offset: 0, align: 'bottom', duration: 500, ease: 'inExpo',
      });
    } else if (partnerType === 'Business') {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 1,
      });
    } else if (partnerType === 'Consumer') {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 0,
      });
    }
  }

  handleSubmitCompany(e) {
    e.preventDefault();
    this.setState(state => ({
      signatureDefaultValue: `${state.firstName} ${state.lastName}`,
    }));
    if (this.state.partnerType === 'Both' || this.state.partnerType === '') {
      if (this.isValidCompany()) {
        scrollToComponent(this.planSelectRef, {
          offset: 0, align: 'bottom', duration: 500, ease: 'inExpo',
        });
        this.setState({ errorsCompany: {}, IsCompanyForm: 3 });
        //  const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
        //  this.setState({ intervalId1: intervalId });
      }
    } else if (this.isValidCompany()) {
      this.setState({ errorsCompany: {}, IsCompanyForm: 4 });
    }
  }

  AckOnchange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }


  finalSubmit(data) {
    this.setState({
      file: data.file,
    }, () => {
      this.setState({ errors: {}, isLoading: true });
      this.props.saveBusinessUser(this.state);
    });
  }

  openModal() {
    this.setState({ modalIsOpen: true, fileError: false });
  }

  afterOpenModal() {
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  fileChangedHandler = (event) => {
    this.setState({ file: event.target.files[0] });
  }

  uploadHandler = () => {
  }

  confirmState() {
    this.setState({ errors: {}, IsCompanyForm: 6 });
  }

  codeOnSubmit(e) {
    e.preventDefault();

    if (this.state.code !== '') {
      this.props.confirmUserEmail(this.state);
    } else {
      const errors = {};
      errors.code = 'Verification code is Required';
      this.setState({
        errors,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }


  componentDidUpdate() {
    const {
      plansDataAffiliate, userInfo, AllPlansForMember,
    } = this.props.data;

    // const { BusinessUserDataStep1 } = this.props;
    const { match: { params }, signupData: { BusinessUserDataStep1 } } = this.props;
    const { BusinessUserDataStep1Data } = this.state;


    const plainDto = {};
    const { plansDataAffiliate1, AllPlansForMember1, userDataLogin1 } = this.state;
    if (userInfo !== undefined) {
      if (typeof userInfo.user !== 'undefined') {
        if (userDataLogin1 !== userInfo) {
          this.setState({
            userDataLogin1: userInfo,
          });
          // If the fusebill payment status is paid.
          if (localStorage.getItem('paymentStatus') === 'paid') {
            this.context.router.history.push('/dashboard');
          }
        }
      }
    }

    if (plansDataAffiliate !== undefined) {
      if (params.affiliateKey !== undefined) {
        if (plansDataAffiliate.result !== undefined) {
          if (plansDataAffiliate.result.affiliateActive === 1) {
            if (plansDataAffiliate1 !== plansDataAffiliate) {
              Object.assign(plainDto, { records: plansDataAffiliate.result.affiliateSubscriptionDto.map });
              this.setState({
                plansDataAffiliate1: plansDataAffiliate,
                AllPlansForMember1: plainDto,
                affiliateId: plansDataAffiliate.result.userId,
                isLoader: false,
              });
              if (plansDataAffiliate.result.affiliateType === 'Both') {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1,
                });
              } else if (plansDataAffiliate.result.affiliateType === 'Business') {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1,
                  showTab: 2,
                  indicatorBusiness: 'active',
                  indicatorConsumer: '',
                });
              } else if (plansDataAffiliate.result.affiliateType === 'Consumer') {
                this.setState({
                  defaultIndex: 0,
                  showTab: 2,
                  indicatorBusiness: '',
                  indicatorConsumer: 'active',
                });
              }
              this.props.getAllPlans({
                pageNumber: 0,
                pageSize: 20,
                searchKeyword: '',
                planUserType: 'Business',
                userId: (plansDataAffiliate.result.userId !== undefined) ? plansDataAffiliate.result.userId : 0,
                affiliateKey: (this.props.match.params.affiliateKey !== undefined) ? this.props.match.params.affiliateKey : '',
              });
            }
          } else {
            this.context.router.history.push('/signup-disabled');
          }
        }
      }
    }
    if (AllPlansForMember !== undefined) {
      if (params.affiliateKey === undefined) {
        if (AllPlansForMember.records !== undefined) {
          if (AllPlansForMember.records.Small !== undefined) {
            if (AllPlansForMember.records.Small.length > 0) {
              if (AllPlansForMember1 !== AllPlansForMember) {
                this.setState({
                  AllPlansForMember1: AllPlansForMember,
                });
              }
            }
            // console.log("Asdsasaa",AllPlansForMember.records.Small)
          }
        }
      }
    }
    if (BusinessUserDataStep1.step1 !== undefined) {
      if (BusinessUserDataStep1Data !== BusinessUserDataStep1) {
        this.setState({
          BusinessUserDataStep1Data: BusinessUserDataStep1,
          firstName: BusinessUserDataStep1.step1.firstName,
          lastName: BusinessUserDataStep1.step1.lastName,
          signatureDefaultValue: BusinessUserDataStep1.step1.signatureDefaultValue,
          companyTitle: BusinessUserDataStep1.step1.companyTitle,
          email: BusinessUserDataStep1.step1.email,
          password: BusinessUserDataStep1.step1.password,
          workPhoneNumber: BusinessUserDataStep1.step1.workPhoneNumber,
          nonWorkPhoneNumber: BusinessUserDataStep1.step1.nonWorkPhoneNumber,
          companyName: BusinessUserDataStep1.step1.companyName,
          acceptCC: BusinessUserDataStep1.step1.acceptCC,
          bankruptcyStatus: BusinessUserDataStep1.step1.bankruptcyStatus,
          dissolvedStatus: BusinessUserDataStep1.step1.dissolvedStatus,
          totalTaxId: BusinessUserDataStep1.step1.totalTaxId,
          streeAddress: BusinessUserDataStep1.step1.streeAddress,
          city: BusinessUserDataStep1.step1.city,
          state: BusinessUserDataStep1.step1.state,
          zipCode: BusinessUserDataStep1.step1.zipCode,
          separateTaxId: BusinessUserDataStep1.step1.separateTaxId,
          enterpriseType: BusinessUserDataStep1.step1.enterpriseType,
          startingYear: BusinessUserDataStep1.step1.startingYear,
          webSite: BusinessUserDataStep1.step1.webSite,
          industryTypeId: BusinessUserDataStep1.step1.industryTypeId,
          taxId: BusinessUserDataStep1.step1.taxId,
          planPriceId: BusinessUserDataStep1.step1.planPriceId,
          readDisclaimer: BusinessUserDataStep1.step1.readDisclaimer,
          readPrivacyPolicy: BusinessUserDataStep1.step1.readPrivacyPolicy,
          readLetterOfAgency: BusinessUserDataStep1.step1.readLetterOfAgency,
          readUserAgreement: BusinessUserDataStep1.step1.readUserAgreement,
          defaultIndex: BusinessUserDataStep1.step1.defaultIndex,

          cRoleName: BusinessUserDataStep1.step1.cRoleName,
          roleName: BusinessUserDataStep1.step1.roleName,

          cFirstName: BusinessUserDataStep1.step1.cFirstName,
          cLastName: BusinessUserDataStep1.step1.cLastName,
          cState: BusinessUserDataStep1.step1.cState,
          cSince: BusinessUserDataStep1.step1.cSince,
          cEmployer: BusinessUserDataStep1.step1.cEmployer,
          cEmail: BusinessUserDataStep1.step1.cEmail,
          cPhone: BusinessUserDataStep1.step1.cPhone,
          cPassword: BusinessUserDataStep1.step1.cPassword,
          cNotification: BusinessUserDataStep1.step1.cNotification,
          cUpdateClaim: BusinessUserDataStep1.step1.cUpdateClaim,
          serviceFeeAgree: BusinessUserDataStep1.step1.serviceFeeAgree,
          bankAccount: BusinessUserDataStep1.step1.bankAccount,
          otherIndustryType: BusinessUserDataStep1.step1.otherIndustryType,

          affiliateKeyId: BusinessUserDataStep1.step1.affiliateKeyId,
          affiliateId: BusinessUserDataStep1.step1.affiliateId,

          caffiliateId: BusinessUserDataStep1.step1.caffiliateId,
          caffiliateKey: BusinessUserDataStep1.step1.caffiliateKey,

          selectedPlanName: BusinessUserDataStep1.step1.selectedPlanName,
          selectedPlanAmount: BusinessUserDataStep1.step1.selectedPlanAmount,

        });
      }
    }
  }


  async componentWillReceiveProps(nextProps) {
    let errors = {};
    errors = this.state.errors;
    const { BusinessUserData } = nextProps.data;
    const isOk = nextProps.data.ConfirmUserEmailData;


    const isemailVerified = nextProps.data.emailVerifyData ? nextProps.data.emailVerifyData : {};
    if (Object.keys(isemailVerified).length > 0) {
      if (isemailVerified.collectMessage !== undefined) {
        if (isemailVerified.collectMessage.messageShort === 'User email already exist') {
          // errors.email = 'This user\'s email address has already been added to Collectively';
          errors.email = 'Email address already exists'
          this.setState({
            isDisable: true,
            errors,
          });
        }
      }
    }
    if (typeof BusinessUserData !== 'undefined') {
      if (!this.state.isLoginCheckS) {
        Auth.signIn(this.state.email.toLowerCase(), this.state.password).then((user) => {
          const jwtToken = user.signInUserSession.accessToken.jwtToken;
          const postInfo = {
            email: this.state.email.toLowerCase(),
            token: jwtToken,
            user,
          };
          this.props.requestApiData(postInfo);
          this.setState({ isLoginCheckS: true });
          // this.context.router.history.push('/dashboard');
          // setTimeout(() => { this.props.history.push('/'); }, 1000);
        }).catch((error) => {
          this.setState({ failedLoginMessages: error.message });
          this.setState({ isLoginCheckS: false });
          if (error.message === 'User is not confirmed.') {
            this.context.router.history.push('/verify-code');
          }
        });
      }
    }
    if (isOk.code === 400) {
      this.setState({
        errorForcodeverify: true,
      });
    }

    // Hit API for saving the Fusebill customer ID in DB---------
    // if (nextProps.data.userInfo.roleName === 'Business-User'
    //     && nextProps.data.userInfo.userObject.planDto.planName !== 'Basic'
    // ) {
    //   this.context.router.history.push('/add-payment-method');
    // }
  }

  verifyEmail() {
    if (this.state.email !== '') {
      this.props.checkEmailVerify({ email: this.state.email });
    }
  }

  render() {
    const {
      errors, isLoading, pageType, enableButtonT, passwordType, passwordColor, affiliateKeyId, countryCode, nonWorkPhoneNumber, firstName, lastName, companyTitle, workPhoneNumber, email, password,
      companyName, streeAddress, showTab, city, zipCode, taxId, webSite, errorsCompany, IsCompanyForm, signatureDefaultValue, signatureFontFamily,
      code, AllPlansForMember1, industryTypeId, separateTaxId, isLoader, enterpriseType, totalTaxId, errorForcodeverify, startingYear, partnerType, defaultIndex, indicatorBusiness, indicatorConsumer, affiliateId,
    } = this.state;
    const {
      AllStates, AllCountryData, plansDataAffiliate, IndustryData, affilateUserList
    } = this.props.data;

    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    const options = [];
    options.push(<option selected disabled key={0} value="">State</option>);
    AllStates.map(item =>
      // return options.push({value: item.stateId, label: item.stateName, name: item.stateName})
      options.push(<option key={item.stateId} value={item.stateId}>{item.stateName}</option>));

    const IndustryDataoptions = [];
    IndustryDataoptions.push({ value: '', label: 'Industry', name: 'Industry' });
    if (IndustryData !== undefined) {
      if (IndustryData.code !== 400) {
        IndustryData.map(item => IndustryDataoptions.push({
          value: item.lookupTypeValueId,
          label: item.displayText,
          name: item.displayText,
        }));
      }
    }
    const optionsSince = [];
    optionsSince.push({ value: '', label: 'Year your business started', name: 'Since' });
    optionsSince.push({ value: 'Prior to 1990', label: 'Prior to 1990', name: 'Since' });


    const currentDate = new Date().getFullYear();
    for (let i = 1990; i <= currentDate; i++) {
      optionsSince.push({ value: i.toString(), label: i, name: i });
    }
    // selecting the first index to select
    const cSelectedSince3 = _.find(optionsSince, { value: startingYear });
    const cDefaultSince3 = cSelectedSince3;
    // console.log(cDefaultSince3)

    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsCountry.push({ value: item.countryCode, label: item.countryCode, name: item.countryCode }));
    } else {
      optionsCountry.push({ value: '+1', label: '+1', name: '+1' });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: countryCode });
    const cDefaultOptionCountry = cSelectedCountry;

    // selecting the first index to select
    const selectedIndustry = _.find(IndustryDataoptions, { value: industryTypeId });
    const defaultOptionIndustry = selectedIndustry;
    // end

    const affilateUserListOption = [];
    affilateUserListOption.push({ value: '', label: 'Select Partner', name: 'Select Partner' });
    if (affilateUserList) {
      affilateUserList.map(item => affilateUserListOption.push({
        value: item.userId,
        label: item.fullName,
        name: item.fullName,
      }));
    }

    const selectedAffilate = _.find(affilateUserListOption, { value: industryTypeId });
    const defaultOptionAffilate = selectedAffilate;


    let tabs;
    if (partnerType === 'Consumer') {
      tabs = (
        <div style={{ display: (showTab === 1) ? 'block' : 'none' }}>
          <Tab className="tab col s6">
            <a
              className={indicatorConsumer}
            >
              I'm a consumer

              </a>

          </Tab>
          <Tab className="tab col s6" disabled>
            <a className={indicatorBusiness}>
              I'm a business
                                  representative

              </a>
            {indicatorBusiness}

          </Tab>

        </div>
      );
    } else if (partnerType === 'Business') {
      tabs = (
        <div style={{ display: (showTab === 1) ? 'block' : 'none' }}>
          <Tab className="tab col s6" disabled>
            <a
              className={indicatorConsumer}
            >
              I'm a consumer

              </a>

          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>
              I'm a business
                                  representative

              </a>
            {indicatorBusiness}

          </Tab>

        </div>
      );
    } else if (showTab === 1) {
      tabs = (
        <div style={{ display: 'block' }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>
              I'm a
                                      consumer

              </a>

          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>
              I'm a business
                                          representative

              </a>
            {indicatorBusiness}

          </Tab>

        </div>
      );
    } else if (localStorage.getItem('consumerTab') === 1) {
      tabs = (
        <div style={{ display: 'block' }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>
              I'm a
                                      consumer

              </a>

          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>
              I'm a business
                                          representative

              </a>
            {indicatorBusiness}

          </Tab>

        </div>
      );
    } else {
      tabs = (
        <div style={{ display: 'block' }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>
              I'm a
                                  consumer

              </a>

          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>
              I'm a business
                                      representative

              </a>
            {indicatorBusiness}

          </Tab>

        </div>
      );
    }

    // end
    return (
      <span>
        {isLoader}
        {loader1}
        {isLoader === false ? (
          <div className="container">
            <div className="main-content">
              <Header />


              {/* <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="modal-content ssingh-up-singnature">
                  <p>Large Enterprise is a company that has over $500 million in annual revenue and/or more than 5000 employees</p>
                </div>
              </Modal> */}
              <div className="white-box">
                <div className="section-content create-account">
                  <div className="row">
                    <div className="col s12 m10 offset-m1">
                      <div className="row">
                        <div className="col s12 m6 create-acc-hdr">
                          <h5> Create Account </h5>
                        </div>
                        <div className="col s12 m6 already-acc">
                          <Link
                            to="/"
                          >
                            Already have an account?

                            </Link>

                        </div>
                      </div>
                      <div className="row">
                        <div className="col s12">

                          <Tabs
                            selectedIndex={defaultIndex}
                            onSelect={defaultIndex1 => this.setState({ defaultIndex: defaultIndex1, errors: {} }, () => {
                              (defaultIndex1 === 1) ? this.props.getPageData(7) : this.props.getPageData(6);
                              this.props.GetAllAffiliateUsersByAffiliateType(defaultIndex1 === 1 ? "Business" : "Consumer")
                              this.props.clearDataEmail();
                              localStorage.clear();
                              this.props.clearSignupData();
                              localStorage.setItem('userTypeFooter', defaultIndex1 === 1 ? 'Business-User' : 'Consumer');
                            })}
                          >
                            <TabList id="tabs-swipe-demo" style={{ display: (showTab === 1) ? 'block' : 'none' }} className="tabs">
                              {tabs}
                            </TabList>

                            <TabPanel className="active ">
                              <div id="test-swipe-1" className="col s12 ">
                                <Consumer
                                  affiliateKey={affiliateKeyId}
                                  plansDataAffiliate={plansDataAffiliate}
                                  partnerType={partnerType}
                                  affiliateId={affiliateId}
                                  email={email}
                                  showTab={showTab}
                                  handlerFromParant={defaultIndex}
                                />
                              </div>
                            </TabPanel>
                            <TabPanel>
                              <div id="test-swipe-2">
                                <form onSubmit={this.handleSubmit} className={IsCompanyForm === 1 ? 'show ' : 'hide'} autoComplete="off">
                                  <div className="row">
                                    <div className="col s12 m12">
                                      <h6 className="tab-heading col s12 ">Personal Information</h6>
                                      <div className="row">
                                        <div className="input-field col s12" ref={(section) => { this.firstNameRef = section; }}>
                                          <TextFieldGroup
                                            field="firstName"
                                            label="First Name*"
                                            value={firstName}
                                            error={errors.firstName}
                                            onChange={this.onChange1}
                                          />
                                        </div>
                                        <div className="input-field col s12" ref={(section) => { this.lastNameRef = section; }}>
                                          <TextFieldGroup
                                            field="lastName"
                                            label="Last Name*"
                                            value={lastName}
                                            error={errors.lastName}
                                            onChange={this.onChange1}
                                          />

                                        </div>
                                        <div className="input-field col s12" ref={(section) => { this.companyTitleRef = section; }}>
                                          <TextFieldGroup
                                            field="companyTitle"
                                            label="Title/Position in Company*"
                                            value={companyTitle}
                                            error={errors.companyTitle}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                        <div className="row phone-signupnew">
                                          <div className="input-field tel-input-lt">
                                            <label className="active">Country Code</label>
                                            <Dropdown
                                              name="cState"
                                              className="browser-default"
                                              options={optionsCountry}
                                              onChange={this._countrySelect}
                                              value={cDefaultOptionCountry}
                                              placeholder="Select an option*"
                                            />
                                          </div>
                                          <div className="input-field tel-input-rt" ref={(section) => { this.newMobilePhoneRef = section; }}>

                                            <MaskInputNumber
                                              field="nonWorkPhoneNumber"
                                              label="Phone Number*"
                                              value={nonWorkPhoneNumber}
                                              error={errors.nonWorkPhoneNumber}
                                              onChange={this.onChange}
                                            />

                                          </div>
                                        </div>
                                        <div className="row phone-signupnew">
                                          <div className="input-field tel-input-lt">
                                            <label className="active">Country Code</label>
                                            <Dropdown
                                              name="cState"
                                              className="browser-default"
                                              options={optionsCountry}
                                              onChange={this._countrySelect}
                                              value={cDefaultOptionCountry}
                                              placeholder="Select an option*"
                                            />
                                          </div>
                                          <div className="input-field tel-input-rt" ref={(section) => { this.workPhoneNumberRef = section; }}>

                                            <MaskInputNumber
                                              field="workPhoneNumber"
                                              label="Work Mobile Number*"
                                              value={workPhoneNumber}
                                              error={errors.workPhoneNumber}
                                              onChange={this.onChange}
                                            />

                                          </div>

                                        </div>
                                        <div className="input-field col s12" ref={(section) => { this.emailRef = section; }}>
                                          <TextFieldGroup
                                            field="email"
                                            label="Email*"
                                            value={email}
                                            error={errors.email}
                                            checkUserExists={this.verifyEmail}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                        <div className="input-field col s12" ref={(section) => { this.passwordRef = section; }}>
                                          <div className="q-rt employer-question">
                                            <TextFieldGroup
                                              field="password"
                                              label="Password*"
                                              value={password}
                                              error={errors.password}
                                              onChange={this.onChange}
                                              type={passwordType}
                                            />
                                          </div>
                                          <span className="question-signup q-icon">
                                            <a onClick={this.viewPassword}>
                                              {' '}
                                              <i
                                                className="small material-icons"
                                              >
                                                visibility

                                                </i>

                                            </a>
                                          </span>
                                          <span className="invalid invalid-password" style={{ color: passwordColor }}> Password Requirements – minimum of 8 characters, 1 capital letter, 1 lower case letter, 1 special character, 1 number.</span>
                                        </div>
                                      </div>
                                    </div>

                                    <SignupText />
                                    <div className="col s12 ">
                                      <div className="divider hdr-bdr " />
                                    </div>
                                    <div className="col s12">
                                      <button
                                        className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 tab-btn"
                                        type="submit"
                                        name="action"
                                      >
                                        Next
                                          <i className="material-icons">arrow_forward</i>
                                      </button>
                                    </div>
                                    <div className="col s12">
                                      <p className="center-align" />
                                    </div>

                                  </div>
                                </form>
                                <form onSubmit={this.handleSubmitCompany} className={IsCompanyForm === 2 ? 'show' : 'hide'}>
                                  <div className="row">
                                    <div className="col s12 m12">
                                      <h6 className="tab-heading col s12">Company Information</h6>
                                      <div className="row">
                                        <div className="input-field col s12" ref={(section) => { this.companyNameRef = section; }}>
                                          <TextFieldGroup
                                            field="companyName"
                                            label="Full Legal Company Name and DBA*"
                                            value={companyName}
                                            id="Full-input"
                                            error={errorsCompany.companyName}
                                            onChange={this.onChange}
                                            classFullLegal="classFullLegal"
                                          />
                                        </div>
                                        <div className="input-field col s12" ref={(section) => { this.streeAddressRef = section; }}>
                                          <TextFieldGroup
                                            field="streeAddress"
                                            label="Street Address*"
                                            value={streeAddress}
                                            error={errorsCompany.streeAddress}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                        <div className="input-field col s6" ref={(section) => { this.cityRef = section; }}>
                                          <TextFieldGroup
                                            field="city"
                                            label="City*"
                                            value={city}
                                            error={errorsCompany.city}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                        <div className="col s6 custom-select custom-select-business" ref={(section) => { this.stateRef = section; }}>
                                          <label className="active font-scale">State*</label>
                                          <select name="state" onChange={this._onSelect}>
                                            {(typeof options !== 'undefined') ? (options) : ''}
                                          </select>

                                          <span
                                            className={errorsCompany.stateError ? 'show invalid' : 'hide'}
                                          >
                                            {errorsCompany.state}

                                          </span>
                                        </div>
                                        <div className="input-field col s6 clear" ref={(section) => { this.zipCodeRef = section; }}>
                                          <TextFieldGroup
                                            field="zipCode"
                                            label="Zip code*"
                                            value={zipCode}
                                            error={errorsCompany.zipCode}
                                            onChange={this.onChange}
                                          />
                                        </div>

                                        <div className="input-field col s6 clear" ref={(section) => { this.taxIdRef = section; }}>

                                          <MaskInputEinNumber
                                            field="taxId"
                                            label="Tax ID (EIN)*"
                                            value={taxId}
                                            error={errorsCompany.taxId}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                        <div className="col s12 company-business">
                                          <p>To help provide you with the best solutions, please choose the size of your company.</p>

                                          <p className="radio-outer">
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="enterpriseType"
                                                onChange={this.onChange}
                                                type="radio"
                                                value="S"
                                                checked={enterpriseType === 'S'}
                                              />
                                              <span>Small Medium Business (SMB)</span>
                                            </label>
                                            <Tooltip id="tooltip-icon" title="Large Enterprise is a company that has over $500 million in annual revenue and/or more than 5000 employees">

                                              <label>
                                                <input
                                                  className="with-gap"
                                                  name="enterpriseType"
                                                  onChange={this.onChange}
                                                  type="radio"
                                                  value="E"
                                                  checked={enterpriseType === 'E'}
                                                />
                                                <span>Large Enterprise</span>
                                              </label>
                                            </Tooltip>
                                          </p>
                                          <div
                                            className={errorsCompany.enterpriseTypeError ? 'show invalid clear' : 'hide'}
                                          >
                                            {errorsCompany.enterpriseType}

                                          </div>

                                        </div>

                                        <div className="col s12 company-business">
                                          <p>Do you have additional business entities or locations with separate EINs?*</p>

                                          <p className="radio-outer">
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="separateTaxId"
                                                onChange={this.onChange}
                                                type="radio"
                                                value="yes"
                                              />
                                              <span>Yes</span>
                                            </label>
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="separateTaxId"
                                                onChange={this.onChange}
                                                type="radio"
                                                value="no"
                                              />
                                              <span>No</span>
                                            </label>
                                          </p>
                                          <div
                                            className={errorsCompany.separateTaxIdError ? 'show invalid clear' : 'hide'}
                                          >
                                            {errorsCompany.separateTaxId}

                                          </div>
                                        </div>
                                        <div className={(separateTaxId === 'yes') ? 'input-field col s12' : 'hide'}>
                                          <TextFieldGroup
                                            field="totalTaxId"
                                            label="How Many *"
                                            value={totalTaxId}
                                            error={errorsCompany.totalTaxId}
                                            onChange={this.onChangeTaxId}
                                          />
                                          <p>For your convenience you can upload multiple locations/entities with their respective EINs from your company profile page once you complete registration.</p>


                                        </div>
                                        <div className="input-field col s12" ref={(section) => { this.webSiteRef = section; }}>
                                          <TextFieldGroup
                                            field="webSite"
                                            label="Website"
                                            value={webSite}
                                            error={errorsCompany.webSite}
                                            onChange={this.onChange}
                                          />
                                        </div>

                                        <div className="input-field col s12">
                                          <Dropdown
                                            className="browser-default"
                                            options={affilateUserListOption}
                                            onChange={this._onSelectForPartner}
                                            value={defaultOptionAffilate}
                                            placeholder="Select an option*"
                                          />
                                        </div>

                                        <div className="col s12 company-business">
                                          <p>Does Your Company Accept Credit Cards*</p>
                                          <p className="radio-outer">
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="acceptCC"
                                                onChange={this.onChange}
                                                value="Y"
                                                type="radio"
                                              />
                                              <span>Yes</span>
                                            </label>
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="acceptCC"
                                                onChange={this.onChange}
                                                value="N"
                                                type="radio"
                                              />
                                              <span>No</span>
                                            </label>
                                          </p>

                                          <div
                                            className={errorsCompany.acceptCCError ? 'show invalid clear' : 'hide'}
                                          >
                                            {errorsCompany.acceptCC}

                                          </div>
                                        </div>

                                        <div className="input-field col s12" >
                                          <Dropdown
                                            className="browser-default"
                                            options={IndustryDataoptions}
                                            onChange={this._onSelectForYears}
                                            value={defaultOptionIndustry}
                                            placeholder="Select an option*"
                                          />
                                          <span
                                            className={errorsCompany.industryTypeId ? 'show invalid' : 'hide'}
                                          >
                                            {errorsCompany.industryTypeId}

                                          </span>
                                        </div>

                                        <div className="input-field col s12">
                                          <Dropdown
                                            name="cState"
                                            className="browser-default"
                                            options={optionsSince}
                                            onChange={this._cSince1}
                                            value={cDefaultSince3}
                                            placeholder="Starting Year*"
                                          />
                                          <span
                                            className={errorsCompany.startingYearError ? 'show invalid' : 'hide'}
                                          >
                                            {errorsCompany.startingYear}

                                          </span>
                                        </div>


                                        <div className="col s12 company-business" ref={(section) => { this.bottomDownRef = section; }}>
                                          <p>Did the company file for bankruptcy since 1/1/04?*</p>
                                          <p className="radio-outer">
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="bankruptcyStatus"
                                                onChange={this.onChange}
                                                type="radio"
                                                value="Y"
                                              />
                                              <span>Yes</span>
                                            </label>
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="bankruptcyStatus"
                                                onChange={this.onChange}
                                                type="radio"
                                                value="N"
                                              />
                                              <span>No</span>
                                            </label>
                                          </p>

                                          <div
                                            className={errorsCompany.bankruptcyStatusError ? 'show invalid clear' : 'hide'}
                                          >
                                            {errorsCompany.bankruptcyStatus}

                                          </div>
                                        </div>

                                        <div className="col s12 company-business" ref={(section) => { this.bottomDownRef2 = section; }}>
                                          <p>Did the company dissolve since 1/1/04?*</p>
                                          <p className="radio-outer">
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="dissolvedStatus"
                                                onChange={this.onChange}
                                                value="Y"
                                                type="radio"
                                              />
                                              <span>Yes</span>
                                            </label>
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="dissolvedStatus"
                                                onChange={this.onChange}
                                                value="N"
                                                type="radio"
                                              />
                                              <span>No</span>
                                            </label>

                                          </p>
                                          <div
                                            className={errorsCompany.dissolvedStatusError ? 'show invalid clear' : 'hide'}
                                          >
                                            {errorsCompany.dissolvedStatus}

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col s12 ">
                                      <div className="divider hdr-bdr " />
                                    </div>
                                    <div className="col s12 back-signupbutton">
                                      <a
                                        className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                                        onClick={this.backClick}
                                      >
                                        <i className="material-icons">arrow_backward</i>
                                        Back

                                        </a>
                                      <button
                                        className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                                        type="submit"
                                        name="action"
                                      >
                                        Next
                                          <i className="material-icons">arrow_forward</i>
                                      </button>

                                    </div>


                                  </div>
                                </form>

                              </div>


                            </TabPanel>
                          </Tabs>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div ref={(section) => { this.termsAndConditionsRef = section; }} className={IsCompanyForm === 4 ? 'section-content left-align term-condition' : 'hide'}>
                  <div className="row">
                    <div className="col s12 m10 offset-m1">
                      <div className="row">
                        <div className="col s12">
                          <h4>Collectively monitors, files and helps you collect from antitrust and class action settlements. In order for us to be able to act on your behalf, we need you to agree to the following</h4>
                        </div>
                      </div>

                      <div className="row">
                        <TermAndCondition
                          termsAndConditionData={this.handleSaveData}
                          termsAndConditionBack={this.backClick}
                          pageType={pageType}
                          backButton={enableButtonT}
                        />
                      </div>

                    </div>
                  </div>
                </div>
                <div className={IsCompanyForm === 3 ? 'section-content settlement' : 'hide'}>
                  <div className="row">
                    <div className="col s12 m12 pad-none">
                      <div className="row">

                        <PlanPage plainDetail={AllPlansForMember1} onPlanSelect={this.onPlanSelectBar} enterpriseType={enterpriseType} totalTaxId={totalTaxId} />
                        <div className="col s12 back-signupbutton">
                          <a
                            className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                            onClick={this.backClick}
                          >
                            <i className="material-icons">arrow_backward</i>
                            Back

                            </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div ref={(section) => { this.signatureRef = section; }} className={IsCompanyForm === 5 ? 'section-content left-align create-signature' : 'hide'}>
                  <SignatureComponent
                    defaultValue={signatureDefaultValue}
                    fontFamily={signatureFontFamily}
                    signBack={this.backClick}
                    finalSubmitData={this.finalSubmit}
                    loader={isLoading}
                    hide
                  />
                </div>

                <div className={IsCompanyForm === 6 ? 'section-content center-align login-content' : 'hide'}>
                  <h2>Confirm Account</h2>
                  <p>Enter the Code recived on registered email and submit.</p>

                  <div className="row">
                    <form className="col s8 offset-s2" onSubmit={this.codeOnSubmit}>
                      <div className="row">
                        <div className="input-field col s12">
                          <TextFieldGroup
                            field="code"
                            label="Code"
                            value={code}
                            error={errors.code}
                            onChange={this.onChange}
                          />
                        </div>
                        <span
                          className={errorForcodeverify ? 'show invalid' : 'hide'}
                        >
                          code is not valid.

                          </span>
                        <div className="col s12">
                          <button
                            className="btn waves-effect waves-light primary-btn col s12"
                            type="submit"
                            name="action"
                          >
                            Confirm
                              <i className="material-icons">arrow_forward</i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        ) : ''}
      </span>
    );
  }
}

Signup.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  data: state.data,
  signupData: state.signupData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    saveBusinessUser,
    saveBusinessUserStep1,
    getAllCountry,
    getAllStates,
    getCityByStateId,
    getAffiliateDetailByAffiliateKey,
    getAllPlans,
    confirmUserEmail,
    clearData,
    getIndustry,
    getBusiness,
    checkEmailVerify,
    requestApiData,
    getPageData,
    clearDataEmail,
    clearSignupData,
    GetAllAffiliateUsersByAffiliateType,

  }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));
